import { useEffect } from "react";
import { useLenis, scrollTo } from "../lib/smoothScroll";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { ChiSiamo } from "../components/ChiSiamo";
import { Impianti } from "../components/Impianti";
import { Cantieri } from "../components/Cantieri";
import { Contatti } from "../components/Contatti";

export default function LandingPage() {
  useLenis();

  useEffect(() => {
    // Handle #anchor on load
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => scrollTo(`#${id}`), 400);
    }
  }, []);

  return (
    <div className="bg-[#0A0C10] text-[#F4F4F0]">
      <Navbar />
      <Hero />
      <ChiSiamo />
      <Impianti />
      <Cantieri />
      <Contatti />
    </div>
  );
}
